import { useDispatch, useSelector } from "react-redux";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import { Disclosure, Transition } from "@headlessui/react";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { GoChecklist, GoTasklist } from "react-icons/go";
import { CgUserList } from "react-icons/cg";
import { AiOutlineProduct } from "react-icons/ai";

import {
  FiGitPullRequest,
  FiMessageSquare,
  FiPackage,
  FiSettings,
  FiThumbsUp,
  FiUser,
  FiUsers,
} from "react-icons/fi";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { HiOutlineInbox } from "react-icons/hi2";
import styles from "./index.module.css";
import environment from "../../../environment";
import { useEffect, useRef, useState } from "react";
import ApiClient from "../../../methods/api/apiClient";
import { sidebar_base } from "../../../actions/sidebar";
import {
  MdLockOutline,
  MdOutlineDisplaySettings,
  MdOutlineHomeWork,
  MdOutlineLocalOffer,
  MdOutlinePayment,
  MdOutlineProductionQuantityLimits,
  MdOutlineReviews,
  MdOutlineSettings,
  MdOutlineVerifiedUser,
} from "react-icons/md";
import { PlanModules } from "./Constant";
import { GrChannel } from "react-icons/gr";
import { CiCircleList, CiUser } from "react-icons/ci";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { AiFillProduct, AiFillQuestionCircle } from "react-icons/ai";
import { FaFileInvoice } from "react-icons/fa";
import { LuListTodo } from "react-icons/lu";
import { PiUserList } from "react-icons/pi";
import { TfiLayoutListThumb } from "react-icons/tfi";
import { RxDashboard } from "react-icons/rx";
import { TbBriefcase } from "react-icons/tb";

const Html = ({ tabclass, isOpen, setCollapsedState }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const navContainerRef = useRef(null);

  const CommonTransitionClasses = {
    enter: "transition duration-300 ease-in-out",
    enterFrom: "transform scale-95 opacity-0",
    enterTo: "transform scale-300 opacity-300",
    leave: "transition duration-300 ease-in-out",
    leaveFrom: "transform scale-300 opacity-300",
    leaveTo: "transform scale-95 opacity-0",
  };
  const DisclouserButtonCommon = {
    onClick: (e) => {
      setCollapsedState(true);
      dispatch(sidebar_base({ value: true }));
    },
  };
  const CommonArrow = (open) => {
    return (
      <TiArrowSortedDown
        className={`${open ? "" : "-rotate-90 transform"
          } transition-all duration-500 h-4 w-4 text-[#7E8B99]`}
      />
    );
  };

  const getSidebarItems = () => {
    const items = [
      {
        key: "omni",
        name: "Omni Channel",
        element: (
          <li className="space-y-2 mt-5">
            <NavLink
              to="/dashboard"
              id="2"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <RxDashboard className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                Dashboard
              </span>
            </NavLink>
            <NavLink
              to="/chatbot"
              id="2"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <FiMessageSquare className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                AI Chatbot
              </span>
            </NavLink>
            <NavLink
              to="/users"
              id="2"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <FiUser className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                Customers
              </span>
            </NavLink>
            <NavLink
              to="/products"
              id="2"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <AiOutlineProduct className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                Products
              </span>
            </NavLink>
            {/* <NavLink
              to="/quote/requests"
              id="2"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }>
              <GoTasklist className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                Quote Requests
              </span>
            </NavLink> */}
            <NavLink
              to="/contactus/requests"
              id="2"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <CgUserList className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                Contact Us Requests
              </span>
            </NavLink>
            <NavLink
              to="/equipment"
              id="2"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <MdOutlineDisplaySettings className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                Equipment
              </span>
            </NavLink>

            <NavLink
              to="/manufacturer"
              id="2"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <MdOutlineHomeWork className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                Manufacturer
              </span>
            </NavLink>
            <NavLink
              to="/take/payment"
              id="2"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <MdOutlinePayment className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                Take Payment
              </span>
            </NavLink>

            <Disclosure as="div" className="space-y-1" defaultOpen={location.pathname.startsWith("/quickbook") && location.pathname != '/quickbook/integration'}>
              {({ open }) => (
                <>
                  <Disclosure.Button
                    className="w-full p-2.5 rounded-md flex items-center justify-between gap-2.5 text-sm font-normal text-[#4A545E] hover:!text-[#115B9D] hover:bg-[#115B9D17] transition-all"
                    onClick={() => {
                      setCollapsedState(true);
                      dispatch(sidebar_base({ value: true }));
                    }}
                  >
                    <div className="flex items-center gap-2.5">
                      <PiUserList className="min-w-[22px] w-[22px] h-[22px]" />
                      <span className="sidebar_text">QuickBook</span>
                    </div>
                    {CommonArrow(open)}
                  </Disclosure.Button>

                  <Transition
                    show={open}
                    enter={CommonTransitionClasses.enter}
                    enterFrom={CommonTransitionClasses.enterFrom}
                    enterTo={CommonTransitionClasses.enterTo}
                    leave={CommonTransitionClasses.leave}
                    leaveFrom={CommonTransitionClasses.leaveFrom}
                    leaveTo={CommonTransitionClasses.leaveTo}
                  >
                    <Disclosure.Panel className="pl-6 space-y-1">
                      <NavLink
                        to="/quickbook/customers"
                        className={({ isActive }) =>
                          "p-2 flex items-center gap-2 text-sm rounded-md text-[#4A545E] hover:!text-[#115B9D] hover:bg-[#115B9D17] " +
                          (isActive && " !text-[#115B9D] !bg-[#115B9D17]")
                        }
                      >
                        <PiUserList className="w-[18px] h-[18px]" />
                        QuickBook Customers
                      </NavLink>

                      <NavLink
                        to="/quickbook/products"
                        className={({ isActive }) =>
                          "p-2 flex items-center gap-2 text-sm rounded-md text-[#4A545E] hover:!text-[#115B9D] hover:bg-[#115B9D17] " +
                          (isActive && " !text-[#115B9D] !bg-[#115B9D17]")
                        }
                      >
                        <LuListTodo className="w-[18px] h-[18px]" />
                        QuickBook Products
                      </NavLink>
                      <NavLink
                        to="/quickbook/integration?tab=online"
                        className={({ isActive }) =>
                          "p-2 flex items-center gap-2 text-sm rounded-md text-[#4A545E] hover:!text-[#115B9D] hover:bg-[#115B9D17] " +
                          (isActive && location.search.includes("tab=online") && " !text-[#115B9D] !bg-[#115B9D17]")
                        }
                      >
                        <MdOutlineSettings className="w-[18px] h-[18px]" />
                        Settings
                      </NavLink>
                    </Disclosure.Panel>
                  </Transition>
                </>
              )}
            </Disclosure>

            {/* ─── QB Desktop ─── */}
            <Disclosure as="div" className="space-y-1" defaultOpen={location.pathname.startsWith("/qb-desktop")}>
              {({ open }) => (
                <>
                  <Disclosure.Button
                    className="w-full p-2.5 rounded-md flex items-center justify-between gap-2.5 text-sm font-normal text-[#4A545E] hover:!text-[#115B9D] hover:bg-[#115B9D17] transition-all"
                    onClick={() => {
                      setCollapsedState(true);
                      dispatch(sidebar_base({ value: true }));
                    }}
                  >
                    <div className="flex items-center gap-2.5">
                      <TbBriefcase className="min-w-[22px] w-[22px] h-[22px]" />
                      <span className="sidebar_text">QB Desktop</span>
                    </div>
                    {CommonArrow(open)}
                  </Disclosure.Button>

                  <Transition
                    show={open}
                    enter={CommonTransitionClasses.enter}
                    enterFrom={CommonTransitionClasses.enterFrom}
                    enterTo={CommonTransitionClasses.enterTo}
                    leave={CommonTransitionClasses.leave}
                    leaveFrom={CommonTransitionClasses.leaveFrom}
                    leaveTo={CommonTransitionClasses.leaveTo}
                  >
                    <Disclosure.Panel className="pl-6 space-y-1">
                      <NavLink
                        to="/qb-desktop/customers"
                        className={({ isActive }) =>
                          "p-2 flex items-center gap-2 text-sm rounded-md text-[#4A545E] hover:!text-[#115B9D] hover:bg-[#115B9D17] " +
                          (isActive && " !text-[#115B9D] !bg-[#115B9D17]")
                        }
                      >
                        <PiUserList className="w-[18px] h-[18px]" />
                        Customers
                      </NavLink>
                      <NavLink
                        to="/qb-desktop/products"
                        className={({ isActive }) =>
                          "p-2 flex items-center gap-2 text-sm rounded-md text-[#4A545E] hover:!text-[#115B9D] hover:bg-[#115B9D17] " +
                          (isActive && " !text-[#115B9D] !bg-[#115B9D17]")
                        }
                      >
                        <LuListTodo className="w-[18px] h-[18px]" />
                        Products
                      </NavLink>
                      <NavLink
                        to="/qb-desktop/estimates"
                        className={({ isActive }) =>
                          "p-2 flex items-center gap-2 text-sm rounded-md text-[#4A545E] hover:!text-[#115B9D] hover:bg-[#115B9D17] " +
                          (isActive && " !text-[#115B9D] !bg-[#115B9D17]")
                        }
                      >
                        <GoChecklist className="w-[18px] h-[18px]" />
                        Estimates
                      </NavLink>
                      <NavLink
                        to="/qb-desktop/invoices"
                        className={({ isActive }) =>
                          "p-2 flex items-center gap-2 text-sm rounded-md text-[#4A545E] hover:!text-[#115B9D] hover:bg-[#115B9D17] " +
                          (isActive && " !text-[#115B9D] !bg-[#115B9D17]")
                        }
                      >
                        <LiaFileInvoiceDollarSolid className="w-[18px] h-[18px]" />
                        Invoices
                      </NavLink>
                      <NavLink
                        to="/qb-desktop/queue-status"
                        className={({ isActive }) =>
                          "p-2 flex items-center gap-2 text-sm rounded-md text-[#4A545E] hover:!text-[#115B9D] hover:bg-[#115B9D17] " +
                          (isActive && " !text-[#115B9D] !bg-[#115B9D17]")
                        }
                      >
                        <GoTasklist className="w-[18px] h-[18px]" />
                        Queue Status
                      </NavLink>

                    </Disclosure.Panel>
                  </Transition>
                </>
              )}
            </Disclosure>

            <NavLink
              to="/order/management"
              id="/order/management"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <MdOutlineLocalOffer className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                Order Management
              </span>
            </NavLink>



            {/* <NavLink
              to="/request-quotes"
              id="/request-quotes"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <TfiLayoutListThumb className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                Request Quotes
              </span>
            </NavLink> */}

            {/* <NavLink
              to="/quickbook/estimates"
              id="/quickbook/estimates"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <MdOutlineLocalOffer className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                QuickBook Estimates
              </span>
            </NavLink>

            <NavLink
              to="/quickbook/invoices"
              id="/quickbook/invoices"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <GoChecklist className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                QuickBook Invoices
              </span>
            </NavLink> */}

            <NavLink
              to="/quickbook/integration"
              id="/quickbook/integration"
              className={({ isActive }) =>
                "p-2.5 rounded-md flex items-center gap-2.5 text-sm font-normal text-[#4A545E] border-l-[3px] border-[#ffffff00] hover:!border-[#115B9D] hover:!text-[#115B9D] hover:bg-[#115B9D17] !no-underline transition-all " +
                (isActive &&
                  " !text-[#115B9D] border-l-[3px] !border-[#115B9D] !bg-[#115B9D17] !font-medium")
              }
            >
              <MdOutlineSettings className="min-w-[22px] w-[22px] h-[22px]" />
              <span className="text-inherit sidebar_text leading-none flex items-center gap-2 justify-between w-full">
                {" "}
                Settings
              </span>
            </NavLink>
          </li>
        ),
      },
    ];
    return items;
  };

  return (
    <>
      <div
        className={`px-[0px] ${isOpen && styles.sm_sidebar}`}
        ref={navContainerRef}
      >
        <h6
          className={`${isOpen ? "py-[12px] text-center" : "py-[12px]"
            } text-xs font-medium text-[#7E8B99]`}
        >
          <p className="flex items-center justify-center gap-4 max-xl:flex-wrap">
            <span className="sidebar_textmain"> MAIN MENU </span>
          </p>
        </h6>
        <ul className="space-y-2 !list-none scrollbar-hide h-[calc(100vh_-_140px)] overflow-auto px-2">
          {getSidebarItems().map((item) => item.element)}
        </ul>
      </div>
    </>
  );
};

export default Html;
